<template>
  <div class="position-relative overflow-auto">
    <div class="mt-sm-2 d-inline-flex flex-nowrap rounded-pill p-1 ai-custom-checkbox welcome-pill-buttons" style="min-width: max-content;">
      <b-button
        size="sm"
        type="button"
        :variant="value === 'ki' ? 'light' : 'link'"
        :class="[
          'rounded-pill px-3 text-nowrap mr-1',
          value === 'ki' ? 'bg-white shadow-sm text-dark border-0' : 'text-secondary'
        ]"
        @click="emitValue('ki')"
      >
        {{ translations[15926] }}
      </b-button>
      <b-button
        size="sm"
        type="button"
        :variant="value === 'berufsgruppe' ? 'light' : 'link'"
        :class="[
          'rounded-pill px-3 text-nowrap mr-1',
          value === 'berufsgruppe' ? 'bg-white shadow-sm text-dark border-0' : 'text-secondary'
        ]"
        @click="emitValue('berufsgruppe')"
      >
        {{ translations[3848] }}
      </b-button>
      <b-button
        v-if="showVolltext"
        size="sm"
        type="button"
        :variant="value === 'volltext' ? 'light' : 'link'"
        :class="[
          'rounded-pill px-3 text-nowrap',
          value === 'volltext' ? 'bg-white shadow-sm text-dark border-0' : 'text-secondary'
        ]"
        @click="emitValue('volltext')"
      >
        {{ translations[10434] }}
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

export type AiCustomCheckboxValue = 'ki' | 'berufsgruppe' | 'volltext';

@Component({})
export default class AiCustomCheckbox extends Vue {
  @Prop({ type: String, default: 'ki' }) value!: AiCustomCheckboxValue;

  @Prop({ type: Boolean, default: true }) showVolltext!: boolean;

  emitValue(mode: AiCustomCheckboxValue) {
    this.$emit('input', mode);
  }

  get translations() {
    return AppModule.translation;
  }
}
</script>

<style lang="scss" scoped>
.welcome-pill-buttons {
  .btn-link {
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
